import { Actions } from '@ngrx/effects';
import { AppState } from '@_store/index.reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyCommunicationRecipientMetierApiService } from '@_services/api/company-communication-recipient-metier-api.service';
import { GeneratedCompanyCommunicationRecipientMetierEffects } from './company-communication-recipient-metier-generated.effects';

@Injectable()
export class CompanyCommunicationRecipientMetierEffects extends GeneratedCompanyCommunicationRecipientMetierEffects {
  constructor(
    actions$: Actions,
    companyCommunicationRecipientMetierApiService: CompanyCommunicationRecipientMetierApiService,
    store$: Store<AppState>
  ) {
    super(actions$, companyCommunicationRecipientMetierApiService, store$);
  }
}
